import { render, staticRenderFns } from "./FullLoading.vue?vue&type=template&id=2645d606"
import script from "./FullLoading.vue?vue&type=script&lang=js"
export * from "./FullLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports